import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type TimeAdjustmentsBySchedRouteInput,
  timeAdjustmentsBySchedRouteInputSchema,
} from "./shared/timeAdjustments.input";
import {
  type TimeAdjustment,
  timeAdjustmentSchema,
} from "./shared/timeAdjustments.output";

/**
 * Metadata for the fetchTimeAdjustmentsBySchedRoute endpoint
 */
export const timeAdjustmentsBySchedRouteMeta = {
  functionName: "fetchTimeAdjustmentsBySchedRoute",
  endpoint: "/timeadjbyschedroute/{SchedRouteID}",
  inputSchema: timeAdjustmentsBySchedRouteInputSchema,
  outputSchema: timeAdjustmentSchema.array(),
  sampleParams: { SchedRouteID: 2401 },
  endpointDescription: "List time adjustments for a specific scheduled route.",
} satisfies EndpointMeta<TimeAdjustmentsBySchedRouteInput, TimeAdjustment[]>;

const { fetch, useHook } = createFetchAndHook<
  TimeAdjustmentsBySchedRouteInput,
  TimeAdjustment[]
>({
  api: wsfScheduleApiMeta,
  endpoint: timeAdjustmentsBySchedRouteMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/timeAdjustments.endpoints").timeAdjustmentsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving time adjustments for a specific scheduled route
 */
export const fetchTimeAdjustmentsBySchedRoute: FetchFactory<
  TimeAdjustmentsBySchedRouteInput,
  TimeAdjustment[]
> = fetch;

/**
 * React Query hook for retrieving time adjustments for a specific scheduled route
 */
export const useTimeAdjustmentsBySchedRoute: HookFactory<
  TimeAdjustmentsBySchedRouteInput,
  TimeAdjustment[]
> = useHook;
